import { Card, CardBody, CardFooter } from "reactstrap";
import PaginationControls from "../specials/PaginationControls";
import { useEffect, useState } from "react";

/**the main large card that contains pagination etc */
const ItemsCard = ({ items, renderItem, itemsPerPage, startPageFrom }) => {
  const [currentItemsShown, setCurrentItemsShown] = useState(items);
  const [currentPageIndex, setCurrentPageIndex] = useState(startPageFrom ?? 0);
  const [firstIndex, setFirstIndex] = useState(
    Math.ceil(currentPageIndex * itemsPerPage)
  );

  const totalPages = Math.ceil(items?.length / itemsPerPage);
  const pages = [];
  for (let i = 1; i <= totalPages; i++) {
    pages.push(i);
  }

  const previous = () => {
    if (currentPageIndex > 0) {
      setCurrentPageIndex((prev) => prev - 1);
    } else setCurrentPageIndex(0);
  };

  const next = () => {
    if (currentPageIndex < totalPages - 1) {
      setCurrentPageIndex((prev) => prev + 1);
    } else setCurrentPageIndex(totalPages - 1);
  };

  useEffect(() => {
    let first_Index = Math.ceil(currentPageIndex * itemsPerPage);
    setFirstIndex(first_Index);
    setCurrentItemsShown(items?.slice(first_Index, first_Index + itemsPerPage));
  }, [items, startPageFrom, currentPageIndex]);

  useEffect(() => {
    setCurrentPageIndex(startPageFrom ?? 0);
  }, [items]);

  return (
    <Card
      className="border-none p-2"
      onClick={() => console.log("card is clicked")}
    >
      <CardBody className="p-0 p-md-2">
        <div style={{ height: "70vh", overflow: "hidden scroll" }}>
          {currentItemsShown?.map((item, key) => (
            <div className="mb-2">{renderItem(item, key)}</div>
          ))}
        </div>
      </CardBody>
      <CardFooter className="bg-transparent py-3">
        <PaginationControls
          next={next}
          previous={previous}
          pages={pages}
          currentPageIndex={currentPageIndex}
          setCurrentPageIndex={setCurrentPageIndex}
        />
      </CardFooter>
    </Card>
  );
};

export default ItemsCard;
